/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "8ff39d50938b51e638ce5608663bd87f8c8d6ff3";
